<template>
    <b-row>
        <b-col md="12">
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row>
                        <b-col cols="12 mb-1">
                            <b-badge variant="light-warning" v-if="form.status === 0">{{ form.status_name }}</b-badge>
                            <b-badge variant="light-success" v-else-if="form.status === 1">{{ form.status_name }}</b-badge>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group
                            label="Target Date"
                            label-for="target_date"
                            >
                                <flat-pickr
                                id="target_date"
                                v-model="form.target_date"
                                class="form-control"
                                placeholder="Target Date"
                                />
                                <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                                <!-- <p>Value: '{{ form.target_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-form-group
                            label="Employees"
                            label-for="employees"
                            >
                                <v-select
                                id="employees"
                                v-model="form.selectedEmployees"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsEmployees"
                                placeholder="Select Employees"
                                multiple
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form.selectedEmployees }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                            label="Title"
                            label-for="title"
                            >
                            <b-form-input
                                id="title"
                                placeholder="Title"
                                v-model="form.title"
                                class="form-control"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                            label="Priority"
                            label-for="priotiry"
                            >
                                <v-select
                                id="priotiry"
                                v-model="form.selectedPriority"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsPriority"
                                placeholder="Select Priority"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form2.selectedPriority }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                            label="Description"
                            label-for="description"
                            >
                            <b-form-textarea
                                id="description"
                                placeholder="Description"
                                v-model="form.description"
                                class="form-control"
                                required
                            />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col md="12">
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file1 !== null"
                            @click="link(form.file1)"
                            >
                            Attachment 1
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file2 !== null"
                            @click="link(form.file2)"
                            >
                            Attachment 2
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file3 !== null"
                            @click="link(form.file3)"
                            >
                            Attachment 3
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file4 !== null"
                            @click="link(form.file4)"
                            >
                            Attachment 4
                            </b-button>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mr-1"
                            pill
                            v-if="this.form.file5 !== null"
                            @click="link(form.file5)"
                            >
                            Attachment 5
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col md="12">
                            <label for="items" class="text-primary font-weight-bolder">Subtasks</label>
                        </b-col>
                        <b-col>
                            <div>
                                <div>
                                <b-form
                                    ref="form"
                                    :style="{height: trHeight}"
                                    class="repeater-form"
                                    @submit.prevent="repeateAgain"
                                >

                                    <!-- Row Loop -->
                                    <b-row
                                    v-for="(item, index) in items"
                                    :id="index"
                                    :key="index"
                                    ref="row"
                                    >

                                    <b-col md="1">
                                        <div>
                                            <b-card-text class="mb-0">
                                                {{ item.status_name }}
                                            </b-card-text>
                                            <b-form-checkbox
                                            v-model="item.status"
                                            :value="1"
                                            @change="statusSubtask(item, index)"
                                            class="custom-control-primary"
                                            />
                                            <!-- <b-form-checkbox
                                            :checked="item.status === 1 ? true : false"
                                            @change="statusSubtask(item.id)"
                                            class="custom-control-primary"
                                            name="check-button"
                                            switch
                                            /> -->
                                        </div>
                                    </b-col>

                                    <!-- Description -->
                                    <b-col>
                                        <b-form-group
                                        label="Description"
                                        label-for="description"
                                        >
                                        <b-form-input
                                            id="description"
                                            v-model="item.description"
                                            type="text"
                                            placeholder="Description"
                                        />
                                        </b-form-group>
                                    </b-col>

                                    <!-- Remove Button -->
                                    <b-col
                                        lg="3"
                                        md="4"
                                        class="mb-50"
                                        v-if="index < numberItems"
                                    >
                                        <b-button
                                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                        variant="outline-primary"
                                        class="mt-0 mt-md-2 mr-1"
                                        @click="updateSubtask(item)"
                                        >
                                            <feather-icon
                                                icon="CheckIcon"
                                                class="mr-25"
                                            />
                                            <span>Update</span>
                                        </b-button>
                                        <b-button
                                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                        variant="outline-danger"
                                        class="mt-0 mt-md-2"
                                        @click="deleteSubtask(item)"
                                        >
                                            <feather-icon
                                                icon="TrashIcon"
                                                class="mr-25"
                                            />
                                            <span>Delete</span>
                                        </b-button>
                                    </b-col>
                                    <b-col
                                        lg="3"
                                        md="4"
                                        class="mb-50"
                                        v-if="index >= numberItems"
                                    >
                                        <b-button
                                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                        variant="outline-primary"
                                        class="mt-0 mt-md-2 mr-1"
                                        @click="addSubtask(item)"
                                        >
                                            <feather-icon
                                                icon="CheckIcon"
                                                class="mr-25"
                                            />
                                            <span>Save</span>
                                        </b-button>
                                        <b-button
                                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                        variant="outline-danger"
                                        class="mt-0 mt-md-2"
                                        @click="removeItem(index)"
                                        >
                                            <feather-icon
                                                icon="XIcon"
                                                class="mr-25"
                                            />
                                            <span>Remove</span>
                                        </b-button>
                                    </b-col>
                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                    </b-row>

                                </b-form>
                                </div>
                                <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                @click="repeateAgain"
                                >
                                <feather-icon
                                    icon="PlusIcon"
                                    class="mr-25"
                                />
                                <span>Add New</span>
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
        <b-col md="12" v-if="permissions.includes('sales-task-update')">
            <b-button
            class="mt-0"
            type="submit"
            variant="primary"
            block
            :disabled="items[0].description === '' ? true : false"
            @click="updateTask()"
            >
                Update Task
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
import {
    BFormTextarea, BDropdownItem, BDropdown, BBadge, BPagination, BFormFile, BImg, BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ImageUploader from 'vue-image-upload-resize'
import { $themeConfig } from "@themeConfig"
import Cleave from 'vue-cleave-component'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import flatPickr from 'vue-flatpickr-component'
import { heightTransition } from '@core/mixins/ui/transition'

export default {
    components: {
        flatPickr,
        VueGoodTable,
        ToastificationContent,
        vSelect,
        ImageUploader,
        Cleave,
        BFormTextarea,
        BPagination,
        BBadge,
        BDropdownItem,
        BDropdown,
        ValidationProvider,
        ValidationObserver,
        BFormFile,
        BImg,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        Prism
    },
    directives: {
        Ripple,
    },
    mixins: [heightTransition],
    data() {
        return {
            form: {
                status: null,
                status_name: '',
                target_date: null,
                selectedEmployees: [],
                optionsEmployees: [],
                workers: [],
                title: '',
                selectedPriority: null,
                optionsPriority: [
                    {value: 1, text: 'Low'},
                    {value: 2, text: 'Normal'},
                    {value: 3, text: 'High'},
                    {value: 4, text: 'Urgent'}
                ],
                description: '',
                file1: null,
                file2: null,
                file3: null,
                file4: null,
                file5: null
            },
            form2: {
                task_id: null
            },
            numberAttachment: 0,
            items: [],
            numberItems: null,
            nextTodoId: 1,
            hasImage: '',
            image: '',
            photo: '',
            pageLength: 10,
            dir: false,
            columns: [
                {
                label: 'Image',
                field: 'image',
                },
                {
                label: 'Code',
                field: 'code',
                },
                {
                label: 'Name',
                field: 'name',
                },
                {
                label: 'Qty',
                field: 'qty',
                },
                {
                label: 'Unit',
                field: 'unit_name',
                },
                {
                label: 'Price',
                field: 'price',
                },
                {
                label: 'Action',
                field: 'action',
                },
            ],
            permissions: [],
            rows: [],
            searchTerm: '',
            errors: '',
            errMessage: ''
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                1 : 'light-success',
                0 : 'light-danger'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    setup() {
        // App Name
        const { baseUrl, apiUrl } = $themeConfig.app;
        return {
            baseUrl,
            apiUrl
        };
    },
    mounted() {
        this.initTrHeight()
    },
    created() {
        window.addEventListener('resize', this.initTrHeight)
        this.getAllPermissions()
        this.getDetails()
        this.getDetailsItem()
        this.getEmployees()
    },
    destroyed() {
        window.removeEventListener('resize', this.initTrHeight)
    },
    methods: {
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        repeateAgain() {
            this.items.push({
                id: this.nextTodoId += this.nextTodoId,
            })

            this.$nextTick(() => {
                this.trAddHeight(this.$refs.row[0].offsetHeight)
            })
        },
        removeItem(index) {
            this.items.splice(index, 1)
            this.trTrimHeight(this.$refs.row[0].offsetHeight)
        },
        initTrHeight() {
            this.trSetHeight(null)
            this.$nextTick(() => {
                this.trSetHeight(this.$refs.form.scrollHeight)
            })
        },
        getDetails() {
            const id = this.$route.params.id
            this.$http.get('sales/task/'+id)
            .then(response => {
                // console.log(response.data.data)
                this.form.status = response.data.data.status
                this.form.status_name = response.data.data.status_name
                this.form.target_date = response.data.data.target_date
                var $datas = response.data.data.worker
                var i
                for(i=0; i<$datas.length; i++) {
                    var $data = {
                        value: $datas[i].id,
                        text: $datas[i].name
                    }
                    this.form.selectedEmployees.push($data)
                }
                this.form.title = response.data.data.title
                this.form.selectedPriority = {value: response.data.data.priority, text: response.data.data.priority_name}
                this.form.description = response.data.data.description
                const { baseUrl } = $themeConfig.app
                if(response.data.data.attachment_1 !== '') {
                    this.form.file1 = baseUrl
                    this.form.file1 += 'storage/sales/task/'
                    this.form.file1 += response.data.data.attachment_1
                }
                if(response.data.data.attachment_2 !== '') {
                    this.form.file2 = baseUrl
                    this.form.file2 += 'storage/sales/task/'
                    this.form.file2 += response.data.data.attachment_2
                }
                if(response.data.data.attachment_3 !== '') {
                    this.form.file3 = baseUrl
                    this.form.file3 += 'storage/sales/task/'
                    this.form.file3 += response.data.data.attachment_3
                }
                if(response.data.data.attachment_4 !== '') {
                    this.form.file4 = baseUrl
                    this.form.file4 += 'storage/sales/task/'
                    this.form.file4 += response.data.data.attachment_4
                }
                if(response.data.data.attachment_5 !== '') {
                    this.form.file5 = baseUrl
                    this.form.file5 += 'storage/sales/task/'
                    this.form.file5 += response.data.data.attachment_5
                }
            })
        },
        getDetailsItem() {
            const id = this.$route.params.id
            this.$http.get('sales/task/'+id+'/items')
            .then(response => {
                // console.log(response.data.data)
                this.numberItems = response.data.data.length
                var $datas = response.data.data
                var i
                for(i=0; i<$datas.length; i++) {
                    var $data = {
                        id: $datas[i].id,
                        description: $datas[i].description,
                        status: $datas[i].status,
                        status_name: $datas[i].status_name
                    }
                    this.items.push($data)
                }
            })
        },
        link(url) {
            window.open(url)
        },
        getEmployees() {
            this.$http.get('employees')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.form.optionsEmployees.push($data)
                }
                // console.log(this.form.optionsEmployees)
            });
        },
        moreAttachment() {
            this.numberAttachment += 1
        },
        statusSubtask($data, $index) {
            this.$http.post('sales/task/item/'+$data.id+'/status')
            .then(response => { 
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Subtask Change',
                        variant: 'primary',
                    },
                })
                this.items.splice($index, 1, {
                    id: response.data.data.id,
                    description: response.data.data.description,
                    status: response.data.data.status,
                    status_name: response.data.data.status_name
                })
            });
        },
        updateTask() {
            if(this.form.target_date === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Target Date Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedEmployees === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Employees Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.title === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Title Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedPriority === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Priority Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.description === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Description Field is required',
                        variant: 'warning',
                    },
                })
            } else {
                let formData = new FormData();
                formData.append("target_date", this.form.target_date)
                var $datas = this.form.selectedEmployees
                var i
                for(i=0; i<$datas.length; i++) {
                    formData.append("worker[]", $datas[i].value)
                }
                formData.append("title", this.form.title)
                formData.append("description", this.form.description)
                formData.append("priority", this.form.selectedPriority.value)
                const id = this.$route.params.id
                this.$http
                .post("sales/task/"+id+"/update", formData)
                .then((response) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Success update Task',
                            variant: 'success',
                        },
                    })
                    location.href = "/sales/task"
                }).catch((errors) => {
                    this.errMessage = errors.response.data.message
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: this.errMessage,
                            variant: 'warning',
                        },
                    })
                    console.log(errors.response)
                });
            }
        },
        addSubtask($data) {
            const id = this.$route.params.id
            this.$http
            .post("sales/task/item/add", {
                task_id: id,
                description: $data.description
            })
            .then((response) => {
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Success Add Subtask',
                        variant: 'success',
                    },
                })
                location.reload()
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
        updateSubtask($data) {
            const id = this.$route.params.id
            this.$http
            .post("sales/task/item/"+$data.id+"/update", {
                task_id: id,
                description: $data.description
            })
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Success Save Subtask',
                        variant: 'success',
                    },
                })
                location.reload()
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
        deleteSubtask($data) {
            this.$http
            .post("sales/task/item/"+$data.id+"/delete")
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Subtask has been Deleted',
                        variant: 'danger',
                    },
                })
                location.reload()
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>